/* eslint-disable @typescript-eslint/no-unused-vars */
import axios from 'axios';
import { dowloadInterface, downloadFileWithdrawlInterface } from '../interfaces/dowloadInterface';
import { withdrawalInterface, updateStatusInterface } from '../interfaces/businessInterface';
import { getStore } from '../storage/';

const url_services = process.env.REACT_APP_API_URL_SERVICES;
const url = process.env.REACT_APP_API_URL;


export const downloadApi = async ({
  fileType,
  status,
  initDate,
  endDate
}: dowloadInterface)=> {
    try {
      const headers = {
        'api-key' : getStore().apiKey,
        'api-secret' : getStore().apiSecret,
      };
      const response = await axios({
        url : `${url_services}/third-party-service/download/file`,
        method : 'get',
        responseType: 'blob',
        params : {
          fileType,
          status,
          initDate,
          endDate
        },
        headers: headers
      })

      return response;
        
    } catch (error: any) {
      return error
    }
}

export const downloadFileWithdrawlApi = async ({
  fileType,
  status,
  fromDate,
  toDate,
  business,
  typeOperation 
}: downloadFileWithdrawlInterface)=> {
    try {
      const token = localStorage.getItem('token');
      const headers = {
        'api-key' : getStore().apiKey,
        'api-secret' : getStore().apiSecret,
        Authorization : `Bearer ${token}`
      };

      const urlFile = `${url}/withdrawals/download/fileWithdrawl`
/*       const response = await axios({
        url : urlFile+
        "?business='"+business
        +"'&status='"+status
        +"'&fromDate='"+fromDate
        +"'&toDate='"+toDate
        +"'&fileType='"+fileType
        +"'&typeOperation='"+typeOperation+"'",
        method : 'get',
        responseType: 'blob',
        headers: headers
      }) */

      const response = await axios({
        url : `${url}/withdrawals/download/fileWithdrawl`,
        method : 'get',
        responseType: 'blob',
        params : {
          business,
          status,
          fromDate,
          toDate,
          fileType,
          typeOperation
        },
        headers: headers
      })
/*       const response = await axios({
        url : `${url}/withdrawals/download/fileWithdrawl`,
        method : 'get',
        responseType: 'blob',
        params : {
          business,
          status,
          fromDate,
          toDate,
          fileType
        },
        headers: headers
      }) */

      return response;
        
    } catch (error: any) {
      return error
    }
}

export const uploadApi = async (file : any)=> {
    const headers = {
      'api-key' : getStore().apiKey,
      'api-secret' : getStore().apiSecret
    };
    let formData = new FormData();
    formData.append('file',file);
    try {
      const response = await axios({
        url : `${url_services}/third-party-service/upload/file`,
        method : 'post',
        data : formData,
        headers: headers
      })

      return response;
        
    } catch (error: any) {
      return error
    }
}

export const withdrawalsUploadFiledApi = async (file : any)=> {
  const headers = {
    'api-key' : getStore().apiKey,
    'api-secret' : getStore().apiSecret,
    'Content-Type': 'multipart/form-data'
  };
  let formData = new FormData();
  formData.append('file',file);
  try {
    const response = await axios({
      url : `${url}/withdrawals/upload/file`,
      method : 'post',
      data : formData,
      headers: headers
    })

    return response;
      
  } catch (error: any) {
    return error
  }
}

export const withdrawalApi = async ({
  id
}: withdrawalInterface)=> {
    try {
      const response = await axios({
        url : `${url}/withdrawals/business/${id}`,
        method : 'get',
      })

      return response;
        
    } catch (error: any) {
      return error
    }
}

export const updateStatusApi = async ({
  id,
  status,
  refPayment,
  business
}: updateStatusInterface)=> {
    try {
      const token = localStorage.getItem('token');
      const headers = {
        Authorization : `Bearer ${token}`
      };
      const response = await axios({
        url : `${url}/withdrawals/update`,
        method : 'put',
        data: {
          id:Number(id),
          status : status,
          refPayment,
          successful: status,
          business: Number(business),
          idUserBank : 'string',
        },
        headers:headers
      })

      return response;
        
    } catch (error: any) {
      console.log(error)
      return error
    }
}

export const requestHttp = async (
    urlEndPoint:string,
    methodRequest:string, 
    data = null, 
    headers:any=null, 
    activeUrl=false
  ) => {
    try{
      const token = localStorage.getItem('token');

      const optionHeaders =  token
      ? 
        headers 
          ? headers['Authorization'] = `Bearer ${token}` 
          : { Authorization : `Bearer ${token}` }
      : headers;
  
      const config = {
        method: methodRequest,
        url: activeUrl ? url_services+urlEndPoint : url+urlEndPoint,
        data: data,
        headers: headers? headers : optionHeaders
      };

      return await axios(config)
    } catch (err:any){
      return errorHandle(err.response.data.message, err.response.data.statusCode, err);
    }
}

const errorHandle = (message:string, statusHttp:number, err:any) => {
  if([401].includes(statusHttp)){
    if(['Unauthorized', 'Bad token'].includes(message)) {
      window.location.href = '/';
    }
  }

  return err.response.data;
}